import { NavLink } from 'react-router-dom';
import { Icons } from 'shared/components/ui/Icons';
import { navDataApp } from 'localData/navData';
import './index.scss';

type TNavigationItem = {
  id: number;
  url: string;
  name: string;
  icon: string;
  disabled: boolean;
  hidden?: boolean;
};

export const Navigation = () => {
  return (
    <nav className="navigation">
      <div className="container">
        <ul className="navigation__list">
          {navDataApp.map((item: TNavigationItem) => {
            if (item.hidden) return null;
            return (
              <li key={item.id} className="navigation__item">
                <NavLink
                  to={item.url}
                  title={item.name}
                  className={({ isActive }) =>
                    `navigation__link${
                      isActive ? ' navigation__link--active' : ''
                    }${item.disabled ? ' navigation__link--disabled' : ''}`
                  }
                >
                  <Icons name={item.icon} />
                  <span>{item.name}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};
